import { Box, Stack, Typography } from '@mui/material';
import { TokenUsageCard } from '@codespeak11/token-client/react';
import { useAuth } from '../auth';

const BRAINDANCE_API_URL = import.meta.env.VITE_BRAINDANCE_API_URL || 'https://api.braindance.net';

export default function BillingSummary() {
  const { getValidToken } = useAuth();

  return (
    <Stack spacing={3}>
      <Box>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Billing Summary
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your token balance and usage across the current billing period.
        </Typography>
      </Box>

      <TokenUsageCard
        getAccessToken={getValidToken}
        apiUrl={BRAINDANCE_API_URL}
        period="current_month"
        showTopSites={true}
        topSitesLimit={5}
      />
    </Stack>
  );
}